// extracted by mini-css-extract-plugin
export var accent = "_2m-4";
export var add = "_2m-j";
export var addIcon = "_2m-k";
export var deleteIcon = "_2m-i";
export var disabled = "_2m-9";
export var ellipsis = "_2m-f";
export var error = "_2m-3";
export var form = "_2m-5";
export var hideFocus = "_2m-2";
export var icon = "_2m-7";
export var input = "_2m-e";
export var listItem = "_2m-h";
export var mediumHeight = "_2m-b";
export var noBorder = "_2m-8";
export var noRadius = "_2m-1";
export var shortHeight = "_2m-a";
export var tallHeight = "_2m-c";
export var textInput = "_2m-0";
export var vertical = "_2m-g";
export var veryTallHeight = "_2m-d";
export var widget = "_2m-6";